import React from 'react';
import Img from 'img';

import s from './image.module.scss';

export default function BlogImage({ image, photo_credit }) {
  return (
    <div className={s.root}>
      <div className={s.imgWrapper}>
        <Img effect src={image.name || 'placeholder-dark'} className={s.img} />
      </div>
      <p className={s.photoCredit}>{photo_credit}</p>
    </div>
  );
}
